export default __webpack_public_path__ + "static/media/b2.bd70dd3d.jpg";